import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../api';
import Swal from 'sweetalert2';

const Profile = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const [passwords, setPasswords] = useState({ current: '', new: '', confirm: '' });
    const [config, setConfig] = useState({ passwordMinLength: 8 });

    // Security config is defaulted locally to min length 8

    const handlePasswordChange = async (e) => {
        e.preventDefault();
        if (passwords.new !== passwords.confirm) {
            Swal.fire('Error', 'New passwords do not match', 'error');
            return;
        }

        // Enforce Super Admin Parameters
        if (passwords.new.length < config.passwordMinLength) {
            Swal.fire('Validation Error', `Password must be at least ${config.passwordMinLength} characters as per security policy.`, 'warning');
            return;
        }

        try {
            const token = localStorage.getItem('token');
            await axios.put(`${API_BASE_URL}/api/users/profile/password`, {
                currentPassword: passwords.current,
                newPassword: passwords.new
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            Swal.fire('Success', 'Password changed successfully. Your session has been terminated for security. Please re-login.', 'success');
            localStorage.clear();
            setTimeout(() => window.location.href = '/', 2000);
        } catch (err) {
            Swal.fire('Error', err.response?.data?.error || 'Failed to update password', 'error');
        }
    };

    return (
        <div>
            <h2 style={{ color: '#2C1A10', marginBottom: '20px' }}>My Profile & Security</h2>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
                {/* Profile Details */}
                <div style={{ backgroundColor: '#fff', borderRadius: '12px', padding: '30px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
                    <h3 style={{ marginTop: 0, color: '#C0722C' }}>Official Identity</h3>
                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '5px' }}>FULL NAME</label>
                        <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>{user.name || 'Secretary User'}</div>
                    </div>
                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '5px' }}>EMAIL ID</label>
                        <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>{user.email || 'secretary@vidhansabha.bih.nic.in'}</div>
                    </div>
                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '5px' }}>ROLE</label>
                        <div style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>{user.role || 'Secretariat Staff'}</div>
                    </div>
                    <div style={{ marginTop: '30px', padding: '15px', backgroundColor: '#F3F0E7', borderRadius: '8px' }}>
                        <div style={{ fontSize: '13px', color: '#2C1A10', fontWeight: '700' }}>Active Session</div>
                        <div style={{ fontSize: '12px', color: '#666' }}>IP: 192.168.1.134 • Chrome / Windows</div>
                        <button style={{ marginTop: '10px', color: '#D32F2F', border: '1px solid #D32F2F', backgroundColor: 'transparent', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>Terminate Other Sessions</button>
                    </div>
                </div>

                {/* Security Settings */}
                <div style={{ backgroundColor: '#fff', borderRadius: '12px', padding: '30px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
                    <h3 style={{ marginTop: 0, color: '#C0722C' }}>Change Password</h3>
                    <form onSubmit={handlePasswordChange}>
                        <div style={{ marginBottom: '15px' }}>
                            <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '5px' }}>CURRENT PASSWORD</label>
                            <input
                                type="password"
                                className="custom-input"
                                value={passwords.current}
                                onChange={e => setPasswords({ ...passwords, current: e.target.value })}
                                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ddd' }}
                                required
                            />
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '5px' }}>NEW PASSWORD</label>
                            <input
                                type="password"
                                className="custom-input"
                                value={passwords.new}
                                onChange={e => setPasswords({ ...passwords, new: e.target.value })}
                                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ddd' }}
                                required
                            />
                        </div>
                        <div style={{ marginBottom: '25px' }}>
                            <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '5px' }}>CONFIRM NEW PASSWORD</label>
                            <input
                                type="password"
                                className="custom-input"
                                value={passwords.confirm}
                                onChange={e => setPasswords({ ...passwords, confirm: e.target.value })}
                                style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ddd' }}
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            style={{
                                width: '100%',
                                padding: '12px',
                                backgroundColor: '#2C1A10',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '8px',
                                fontWeight: '700',
                                cursor: 'pointer'
                            }}
                        >
                            Update Credentials
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Profile;
